export default "__VITE_ASSET__DeEG7E_R__"